import {HrToolAiCapabilityLevel, HrToolAiCapabilityType} from '@frontend/shared-api';

export interface HrToolAiCapabilityPresentation {
  icon: string;
  colorClass: string;
}

export const HR_TOOL_AI_CAPABILITY_PRESENTATION: Record<
  HrToolAiCapabilityType,
  HrToolAiCapabilityPresentation
> = {
  [HrToolAiCapabilityType.GENERATE_AND_CREATE]: {
    icon: 'pi pi-file-edit',
    colorClass: 'text-criteria-1',
  },
  [HrToolAiCapabilityType.SEARCH_AND_UNDERSTAND]: {icon: 'pi pi-comment', colorClass: 'text-blue'},
  [HrToolAiCapabilityType.ANALYZE_AND_DETECT]: {
    icon: 'pi pi-chart-bar',
    colorClass: 'text-criteria-3',
  },
  [HrToolAiCapabilityType.RECOMMEND_AND_MATCH]: {
    icon: 'pi pi-bullseye',
    colorClass: 'text-criteria-2',
  },
  [HrToolAiCapabilityType.PREDICT]: {icon: 'pi pi-chart-line', colorClass: 'text-criteria-5'},
  [HrToolAiCapabilityType.AUTOMATE]: {icon: 'pi pi-cog', colorClass: 'text-criteria-4'},
  [HrToolAiCapabilityType.ACT_AGENTICALLY]: {
    icon: 'pi pi-microchip-ai',
    colorClass: 'text-criteria-7',
  },
};

export const HR_TOOL_AI_CAPABILITY_LEVEL_RANK: Record<HrToolAiCapabilityLevel, number> = {
  [HrToolAiCapabilityLevel.NOT_AVAILABLE]: 0,
  [HrToolAiCapabilityLevel.BASIC]: 1,
  [HrToolAiCapabilityLevel.ADVANCED]: 2,
  [HrToolAiCapabilityLevel.COMPREHENSIVE]: 3,
};

export const HR_TOOL_AI_CAPABILITY_MAX_RANK = 3;

export const HR_TOOL_AI_CAPABILITY_LEVEL_TEXT_CLASS: Record<HrToolAiCapabilityLevel, string> = {
  [HrToolAiCapabilityLevel.NOT_AVAILABLE]: '',
  [HrToolAiCapabilityLevel.BASIC]: 'text-blue',
  [HrToolAiCapabilityLevel.ADVANCED]: 'text-green',
  [HrToolAiCapabilityLevel.COMPREHENSIVE]: 'text-green',
};
